import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	exportErrorFlagDefaultTitle: {
		id: 'issue-navigator-action-export-issues.common.export-error-flag.export-error-flag-default-title',
		defaultMessage: 'We couldn’t export your issues',
		description: 'Title of export error flag, shown when something wrong happened',
	},
	exportErrorFlagDefaultDescription: {
		id: 'issue-navigator-action-export-issues.common.export-error-flag.export-error-flag-default-description',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Description of export error flag, shown when something wrong happened',
	},
});

export default messages;
